/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');
var Scaffold = require('common/layout/Scaffold');

var GetLicenseDashboard = require('../../license-dashboard/services/GetLicenseDashboard');
var GetEntityLocations = require('../../common/services/GetEntityLocations');

var LicenseAddressChangeView = require('../views/LicenseAddressChangeView');

module.exports = function(entityId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetLicenseDashboard(licenseId), GetEntityLocations(entityId))
    .done(function(licenseDashboard, entityLocations) {
      NavUtils.navigate('ext/nondep/entity/' + entityId + '/license/' + licenseId + '/change-address');

      Scaffold.content.show(
        new LicenseAddressChangeView({
          isReadOnly: false,
          viewMode: 'ext',
          model: new Backbone.Model({
            entityId: entityId,
            licenseId: licenseId,
            entityLocations: entityLocations,
            licenseDashboard: licenseDashboard
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
